import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';
import Jobs from './screens/jobs';

const routes = [
  {
    component: Jobs,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.JOBS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routes;